/**
 * @desc 查询竞价终止交易详情
 */
import { HaltRecordEntity } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryAuctionHaltParameter = {
  id?: string
}

const method = 'GET'
const url = '/trade/operation/auction/halt/detail'

export const queryAuctionHaltApi = (
  params?: QueryAuctionHaltParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<HaltRecordEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryAuctionHaltApi.method = method
queryAuctionHaltApi.url = url
